import { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine";
import { useMap } from "react-leaflet";

L.Marker.prototype.options.icon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png"
});

function hasValidCoords(point) {
  return point && !isNaN(parseFloat(point.lat)) && !isNaN(parseFloat(point.lng));
}

function MapComponent({ startPoint, endPoint }) {
  const map = useMap();
  const [routingControl, setRoutingControl] = useState(null);

  useEffect(() => {
    if (!map) return;

    const initialRoutingControl = L.Routing.control({
      waypoints: [],
      lineOptions: {
        styles: [{ color: "#1cbcb4", weight: 4 }]
      },
      show: false,
      addWaypoints: false,
      routeWhileDragging: false,
      draggableWaypoints: false,
      showAlternatives: false,
      fitSelectedRoutes: true
    });

    initialRoutingControl.addTo(map);
    setRoutingControl(initialRoutingControl);

    // eslint-disable-next-line
  }, [map]);

  // Update routing control with new waypoints when props change
  useEffect(() => {
    if (!routingControl) return;

    if (!hasValidCoords(startPoint) || !hasValidCoords(endPoint)) {
      routingControl.setWaypoints([]);
      return;
    }

    const newWaypoints = [
      L.latLng(parseFloat(startPoint.lat), parseFloat(startPoint.lng)),
      L.latLng(parseFloat(endPoint.lat), parseFloat(endPoint.lng))
    ];

    routingControl.setWaypoints(newWaypoints);
  }, [startPoint, endPoint, routingControl]);

  return null;
}

export default MapComponent;
